<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>商品列表</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleAdd">添加商品</el-button>
                </el-col>
            </el-row>
        </div>
        <el-form :inline="true" ref="formInline" :model="formInline" class="demo-form-inline">
            <el-form-item label="商品名称" prop="name">
                <el-input v-model="formInline.name" placeholder="商品名"></el-input>
            </el-form-item>
            <el-form-item label="分类选择" prop="categoryId">
                <el-select v-model="formInline.categoryId" placeholder="分类" @change="categoryChoose">
                    <el-option v-for="item in catogreyArr" :key="item.categoryId" :label="item.name" :value="item.categoryId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间" prop="dayStart">
                <el-date-picker v-model="formInline.dayStart" type="date" placeholder="选择日期" @change="startChange" :picker-options="pickerOptionsStart">
                </el-date-picker>
                -
                <el-date-picker v-model="formInline.dayEnd" type="date" placeholder="选择日期" :picker-options="pickerOptionsEnd" @change="endChange">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="条形码编号" prop="productDetailNo">
                <el-input v-model="formInline.productDetailNo" placeholder="编号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="Search">查询</el-button>
                <el-button @click="resetForm('formInline')">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="fetchList" :default-sort="{prop: 'date', order: 'descending'}" v-loading="loading" element-loading-text="拼命加载中">
            <el-table-column prop="productDetailId" label="ID">
            </el-table-column>
            <el-table-column prop="name" label="商品名称">
            </el-table-column>
            <el-table-column prop="rental" label="租金" sortable>
            </el-table-column>
            <el-table-column prop="deposit" label="押金" sortable>
            </el-table-column>
            <el-table-column prop="rentalCount" label="租赁次数" sortable>
            </el-table-column>
            <el-table-column prop="productCount" label="设备数量" sortable>
            </el-table-column>
            <el-table-column inline-template :context="_self" prop="created" label="创建时间">
                <span v-if="row.created">{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" prop="isOnline" label="商品状态">
                <span v-if="row.isOnline">上架</span>
                <span v-else>下架</span>
            </el-table-column>
            <el-table-column inline-template :context="_self" width="200" label="操作">
                <span>
                                            <el-button @click="handleEquipment($index, row)" type="text" size="small">设备管理</el-button>
                                            <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
                                            <el-button @click="handleOff($index, row)" type="text" size="small"  v-if="Role === '1' && row.isOnline">下架</el-button>
                                            <el-button @click="handleOn($index, row)" type="text" size="small"  v-if="!row.isOnline">上架</el-button>
                                            <el-button @click="handleView($index, row)" type="text" size="small">查看库存</el-button>
                                            <el-button @click="handleFreash($index, row)" type="text" size="small">更新商品统计</el-button>
                                        </span>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="20" layout="total, prev, pager, next" :total="totalNum">
        </el-pagination>

        <el-dialog title="查看库存" :visible.sync="dialogTableVisible" size="large">
            <vue-event-calendar :events="demoEvents" @day-changed="dayChange" v-if="dialogTableVisible">
                <template slot-scope="props">
                    <div v-for="(event, index) in props.showEvents" class="event-wrapper" >
                      <!-- In here do whatever you want, make you owner event template -->

                        <div  v-for="item in event.title" class="event-item">
                            {{item.text}}
                        </div>

                    </div>
</template>
    </vue-event-calendar>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getProductDetailsOnly,
        getProductCategories,
        filterProductDetails,
        removeProduct,
        patchProductDetails,
        getProductdetailCount,
        getMount,
        getProductRent,
        putProduct
    } from '../../api/version'

    export default {
        data() {
            return {
                Role: sessionStorage.power,
                clicked: false,
                demoEvents: [],
                loading: false,
                dialogTableVisible: false,
                totalNum: 0,
                currentPage: 1,
                fetchList: [],
                curPro: '',
                formInline: {
                    name: '',
                    categoryId: '',
                    dayStart: '',
                    dayEnd: '',
                    productDetailNo: ''
                },
                catogreyArr: [],
                pickerOptionsStart: {
                    disabledDate(time) {

                    }
                },
                pickerOptionsEnd: {
                    disabledDate(time) {

                    }
                },
            }
        },

        created() {
            //获取商品列表，除了选配商品
            let filter = JSON.stringify({
                "limit": 20,
                "skip": 0,
                'where': {
                    'accessoryType': 0
                }
            })
            getProductDetailsOnly(sessionStorage.userId, filter).then(res => {
                console.log(res)
                this.fetchList = res.data
            }, err => {
                console.log(err)
            })

            getProductdetailCount(sessionStorage.userId, JSON.stringify({

                'accessoryType': 0

            })).then(res => {
                console.log(res.data)
                this.totalNum = res.data.count
            })

            //获取分类
            getProductCategories().then(res => {
                console.log(res, '分类')
                this.catogreyArr = res.data
            }, err => {
                console.log(err)
            })
        },

        methods: {

            //获取某月有多少天
            getLastDay(year, month) {
                var new_year = year; //取当前的年份
                var new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）
                if (month > 12) {
                    new_month -= 12; //月份减
                    new_year++; //年份增
                }
                var new_date = new Date(new_year, new_month, 1); //取当年当月中的第一天
                return (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate(); //获取当月最后一天日期
            },

            handleFreash(index, row) {
                putProduct(sessionStorage.userId, row.productDetailId).then(res => {
                    if (res.data) {
                        console.log(res.data)
                        this.fetchList.forEach((item, index) => {
                            if (item.productDetailId === res.data.productDetailId) {
                                this.fetchList[index] = res.data
                                this.$message({
                                    type: 'success',
                                    message: '更新成功!'
                                });
                            }
                        })
                    }
                })
            },
            dayChange(v) {
                console.log(v)
                if (v.events.length) {
                    let filter = {
                        'where': {
                            'date': v.events[0].date.split('/').join('-'),
                            'productDetailId': this.curPro,
                            'status': 1
                        },
                        'include': 'order'
                    }
                    getProductRent(sessionStorage.userId, JSON.stringify(filter)).then(res => {
                        console.log(res)
                        if (res.data.length) {
                            this.demoEvents.forEach((item, index) => {
                                if (item.date === v.events[0].date) {
                                    this.demoEvents[index].title = []
                                    res.data.forEach(item2 => {
                                        this.demoEvents[index].title.push({
                                            'text': `订单号： ${item2.order.orderNo}`
                                        })
                                    })

                                }
                            })
                        }
                    })
                }

            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.loading = true
                let filter = JSON.stringify({
                    "limit": 20,
                    "skip": 20 * (--val),
                    'where': {
                        'accessoryType': 0
                    }
                })
                getProductDetailsOnly(sessionStorage.userId, filter).then(res => {
                    console.log(res)
                    this.fetchList = res.data
                    this.loading = false;
                }, err => {
                    console.log(err)
                })
            },
            handleEdit(index, row) {
                //编辑
                this.$router.push('/editProduct/' + row.productDetailId)
            },
            handleOff(index, row) {
                //下架
                patchProductDetails(sessionStorage.userId, row.productDetailId, {
                    isOnline: false
                }).then(res => {
                    console.log(res)
                    if (res.data) {
                        row.isOnline = false
                        this.$message({
                            message: '下架成功',
                            type: 'success'
                        });
                    }
                }, err => {
                    this.$message.error(err.response.data.error.message)

                })
            },
            handleOn(index, row) {
                //上架
                patchProductDetails(sessionStorage.userId, row.productDetailId, {
                    isOnline: true
                }).then(res => {
                    console.log(res)
                    if (res.data) {
                        row.isOnline = true
                        this.$message({
                            message: '成功上架',
                            type: 'success'
                        })
                    }
                })
            },
            handleView(index, row) {
                this.curPro = row.productDetailId

                function GetDateStr(AddDayCount) {
                    var dd = new Date();
                    dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
                    var y = dd.getFullYear();
                    var m = dd.getMonth() + 1; //获取当前月份的日期
                    var d = dd.getDate();
                    return y + "-" + m + "-" + d;
                }

                let nextD = GetDateStr(30)
                let y = nextD.split('-')[0]
                let m = nextD.split('-')[1]
                let d = this.getLastDay(y,m)
                console.log(d,'d')
                //查看库存
                this.dialogTableVisible = true
                getMount(sessionStorage.userId, row.productDetailId, GetDateStr(0), y+'-'+m+'-'+d).then(res => {
                    console.log(res)
                    this.demoEvents = []
                    for (var i in res.data.result) {
                        console.log((i + '').split('-').join('/'))
                            this.demoEvents.push({
                                'date': (i + '').split('-').join('/'),
                                'title': [],
                                'number': res.data.result[i]
                            })

                    }
                })
            },
            categoryChoose() {

            },
            handleEquipment(index, row) {
                this.$router.push('/equipment/' + row.productDetailId)
            },
            resetForm(formName) {
                this.formInline.dayEnd = ''
                this.$refs[formName].resetFields();
            },
            handleAdd() {
                //添加商品
                this.$router.push('/addProduct')
            },
            Search() {
                //搜索
                let data = {}
                data.accessoryType = 0
                this.formInline.name ? data.name = {
                    'like': '%25' + this.formInline.name + '%25'
                } : ''
                this.formInline.productDetailNo ? data.productDetailNo = this.formInline.productDetailNo : ''
                this.formInline.categoryId ? data.categoryId = this.formInline.categoryId : ''
                if (this.formInline.dayStart && !this.dayEnd) {
                    data.created = {
                        gt: this.formInline.dayStart
                    }
                } else if (!this.formInline.dayStart && this.formInline.dayEnd) {
                    data.created = {
                        lt: this.formInline.dayStart
                    }
                } else if (this.formInline.dayStart && this.formInline.dayEnd) {
                    data.created = {
                        between: [this.formInline.dayStart, this.formInline.dayEnd]
                    }
                }
                console.log(data)
                let search = {
                    'where': data
                }
                console.log(JSON.stringify(search))
                filterProductDetails(JSON.stringify(search)).then(res => {
                    this.fetchList = res.data
                }, err => {
                    console.log(err)
                })

                getProductdetailCount(sessionStorage.userId, JSON.stringify(search.where)).then(res => {
                    console.log(res.data)
                    this.totalNum = res.data.count
                })
            },
            startChange(val) {
                console.log(val)
                this.pickerOptionsEnd = {
                    disabledDate(time) {
                        return time.getTime() < new Date(val).getTime();
                    }
                }
            },
            endChange(val) {
                console.log(val)
                this.pickerOptionsStart = {
                    disabledDate(time) {
                        return time.getTime() > new Date(val).getTime();
                    }
                }
            }

        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .cal-events p.time {
        display: none
    }

    .event-wrapper {
        margin-top: 15px;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// ProductList.vue?5e61503f